<template>
    <sidebar-layout :moduleCode="moduleCode">
        <template v-slot:aside-main-menu>
        	<gestao-menu :moduleCode="moduleCode"></gestao-menu>
        </template>

        <template v-slot:main>
            <div :class="`${moduleCode}-page`" class="pt-3 px-md-4 pt-md-4 pb-0">
                <slot></slot>
            </div>
        </template>

    </sidebar-layout>
</template>

<script>

    import ModuleMixin from '../shared/mixins/ModuleMixin';

    export default {
        mixins: [
            ModuleMixin,
        ],
		components: {
		    GestaoMenu: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "manage-menu" */ '@/app/shared/components/menu/GestaoMenu'),
		}
	}

</script>